import { assetServices } from "./services";
import { Promise } from "es6-promise";

export const assetActions = {
  getAssetStatus,
  getAggregateData,
  getUsersList
};

function getAssetStatus(params) {
  return new Promise(function(resolve, reject) {
    resolve(assetServices.getAssetStatus(params));
  });
}

function getAggregateData(params) {
  return new Promise(function(resolve, reject) {
    resolve(assetServices.getAggregateData(params));
  });
}

function getUsersList(params) {
  return new Promise(function(resolve, reject) {
    resolve(assetServices.getUsersList(params));
  });
}
